import {useState} from "react";
import i18next from "i18next";

export const usePasswordValidation = () => {
  const [passwordValidation, setPasswordValidation] = useState([]);
  const [confirmValidation, setConfirmValidation] = useState([]);

  const validatePassword = (value = "", metadata) => {
    const rules = [
      {
        show: metadata?.required,
        rule: i18next.t("general:Password is required"),
        passed: value.length > 0,
      },
      {
        show: metadata?.validation?.minLength,
        rule: i18next.t("general:at least 8 characters"),
        passed: value.length >= metadata?.validation?.minLength,
      },
      {
        show: metadata?.validation?.requireLower,
        rule: i18next.t("general:one lowercase letter"),
        passed: /[a-z]/.test(value),
      },
      {
        show: metadata?.validation?.requireUpper,
        rule: i18next.t("general:one uppercase letter"),
        passed: /[A-Z]/.test(value),
      },
      {
        show: metadata?.validation?.requireNumber,
        rule: i18next.t("general:one digit"),
        passed: /\d/.test(value),
      },
      {
        show: metadata?.validation?.requireSpecial,
        rule: i18next.t("general:one special character (!@#$%&)"),
        passed: /[!@#$%&*]/.test(value),
      },
    ];

    setPasswordValidation(rules);
    return rules.every((r) => !r.show || r.passed);
  };

  const validateConfirmPassword = (value, password, metadata) => {
    const passed = value && value === password;

    setConfirmValidation([
      {
        show: metadata?.required,
        rule: i18next.t("general:Confirm password is required"),
        passed: !!value,
      },
      {
        show: metadata?.validation?.mustMatch,
        rule: i18next.t("general:Passwords do not match"),
        passed,
      },
    ]);

    return passed;
  };

  return {
    passwordValidation,
    confirmValidation,
    validatePassword,
    validateConfirmPassword,
  };
};
